import React from 'react';

import { flagStyles } from '../settings';

const SvgBZ = (): JSX.Element => (
  <img
    style={{
      backgroundPosition: '-840px 0px',
      ...flagStyles
    }}
    alt=""
  />
);

export default SvgBZ;
